import React, { Component } from 'react';
import { Link } from "react-router-dom";

import TermView from './TermView';
import TermIndexList from './TermIndexList';
import CollapsibleCard from './CollapsibleCard';
import DictionaryInfo from './DictionaryInfo';

import config from "./../config";

class TermViewContainer extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/es/term/';

		this.state = {
			found: true
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.entry_id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// Athuga hvort breytur hafi breyst og hvort component eigi að uppfærast

		if (this.props.match && this.props.match.params.entry_id && prevProps.match.params.entry_id != this.props.match.params.entry_id) {
			this.fetchData();
		}
	}

	fetchData() {
		// Sæki gögn til APA

		fetch(this.url+this.props.match.params.entry_id)
			.then(function(response) {
				if (!response.ok) {
					this.setState({
						found: false
					})

					return false;
				}
				else {
					return response.json();
				}
			}.bind(this))
			.then(function(json) {
				if (json) {
					this.setState({
						found: true,
						data: json
					})
				}
			}.bind(this));

		window.scrollTo(0, 0);
	}

	render() {
		let dataItem = this.state.data;

		if (!this.state.found) {
			return (
				<div className="row">
					<div className="col-12 col-sm-5 col-md-3">

					</div>

					<div className="col-12 col-sm-7 col-md-9">
						<ul className="list-group mb-4 dictionary-list">
							<li className="list-group-item text-center">
								<div className="h5 mt-3 mb-4">Þessi færsla finnst ekki.</div>
							</li>
						</ul>
					</div>
				</div>
			);
		}
		else if (dataItem) {
			let termIndexSearchParams = {
				ordabok: dataItem.fkdictionary
			};

			// Finnum tungumál sem lista er raðað eftir.
			let sortLang = this.props.order || 'IS';

			//	Ef röðunarmál er annað en íslenska þá færum við þá færslu fremst í listann yfir orð
			if (sortLang != 'IS' && dataItem.words.length > 0) {
				dataItem.words = dataItem.words.sort(function(x, y) {
					return x.fklanguage == sortLang ? -1 : y.fklanguage == sortLang ? 1 : 0;
				});
			}
			let wordIndex = dataItem.words && dataItem.words.length > 0 ? dataItem.words[0].rownum : 0;

			return (
				<div className="row">
					<div className="col-12 col-sm-5 col-md-3">
						<div className="index-column">

							<Link className="btn btn-info btn-block mb-2" to="/">&lt; Til baka á forsíðu</Link>

							<CollapsibleCard title={'Uppflettiorð'+(window.ordabankiData && window.ordabankiData.dictionaries ? ': <strong>'+window.ordabankiData.dictionaries[dataItem.fkdictionary]+'</strong>' : '')} mobileMenu={true} className="gray mb-4 tight-card">
								<TermIndexList term_id={dataItem.id} 
									startIndex={wordIndex} 
									searchParams={termIndexSearchParams} />
							</CollapsibleCard>

						</div>

					</div>

					<div className="col-12 col-sm-7 col-md-9">
						<DictionaryInfo ordabok={dataItem.fkdictionary} />
	
						{
							this.state.data &&
							<div className={'dictionary-entry card'}>
								<div className={'card-body'}>

									<TermView data={dataItem} single={true} />

								</div>
							</div>
						}
					</div>
				</div>
			);
		}
		else {
			return null;
		}
	}
}

export default TermViewContainer;



// WEBPACK FOOTER //
// ./src/components/TermViewContainer.js